import React from 'react';
import * as R from 'ramda';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// feature fleet/equipment-component
import EquipmentComponentForm from '../forms/equipment-component-form';
// feature fleet-profile
import { TableCell } from '../components/table-cells';
//////////////////////////////////////////////////

const columnSettings = {
  [GC.FIELD_COMPONENT_ID]: {
    width: 150,
    name: 'titles:component-id',
  },
  createdFromSharedComponent: {
    width: 150,
    type: 'boolean',
    filter: { type: 'boolean' },
    name: 'titles:shared-component',
  },
  [GC.FIELD_COMPONENT_TYPE]: {
    width: 150,
    name: 'titles:type',
    customComponent: (row) =>
      <TableCell text={R.path(['data', GC.FIELD_COMPONENT_TYPE, GC.FIELD_DISPLAYED_VALUE], row)} />,
    filter: {
      type: 'string',
      getFieldUiValue: R.path([GC.FIELD_COMPONENT_TYPE, GC.FIELD_DISPLAYED_VALUE]),
    },
  },
  [GC.FIELD_WARRANTY_EXPIRATION]: {
    filter: { type: 'date' },
    name: 'titles:warranty-expiration-date',
  },
  [GC.FIELD_INSTALL_DATE]: {
    filter: { type: 'date' },
    name: 'titles:installed-date',
  },
  [GC.FIELD_REPLACE_OR_REMOVE_DATE]: {
    filter: { type: 'date' },
    name: 'titles:removed-date',
  },
  [GC.FIELD_INSTALLED]: {
    width: 160,
    type: 'boolean',
    name: 'titles:installed',
    filter: { type: 'boolean' },
  },
  [GC.FIELD_COMPONENT_MANUFACTURER]: {
    width: 150,
    name: 'titles:manufacturer',
    customComponent: (row) =>
      <TableCell text={R.path(['data', GC.FIELD_COMPONENT_MANUFACTURER, GC.FIELD_DISPLAYED_VALUE], row)} />,
    filter: {
      type: 'string',
      getFieldUiValue: R.path([GC.FIELD_COMPONENT_MANUFACTURER, GC.FIELD_DISPLAYED_VALUE]),
    },
  },
  [GC.FIELD_SERIAL_NUMBER]: {
    width: 150,
    name: 'titles:serial-number',
  },
  [GC.FIELD_SPECIFICATION]: {
    width: 400,
    name: 'titles:specification',
  },
};

const defaultReportFields = R.keys(columnSettings);

const report = {
  [GC.FIELD_TYPE]: GC.TRUCK_PROFILE_UI_REPORTS,
  [GC.FIELD_GUID]: `${GC.TRUCK_PROFILE_UI_REPORTS}EquipmentComponent`,
  fields: G.mapIndexed((name, sequence) => ({ name, sequence }), defaultReportFields),
};

export const truckEquipmentComponentSettings = {
  report,
  columnSettings,
  defaultReportFields,
  withResizableColumns: true,
  withUiFiltersAndEditView: true,
  groupName: 'equipmentComponent',
  includeItemListToTablePropsMemoDeps: true,
  additionalTableSettings: { searchableTitles: true },
  itemTitleArr: ['titles:equipment-component', 'Equipment Component'],
  formGroupTitleArr: ['titles:equipment-component', 'Equipment Component'],
  endpoints: {
    list: 'truckComponentList',
    createOrUpdate: 'truckComponent',
    remove: 'getCurrentTruckComponentEndpoint',
  },
  // helpers
  rowBgFunction: (_, { installed }) =>
    G.getThemeByCond(G.isFalse(installed), 'colors.lightGrey', 'colors.white'),
  makeInitialValues: (initialValues) => {
    const { componentType, componentManufacturer } = initialValues;

    return {
      ...initialValues,
      [GC.FIELD_COMPONENT_TYPE]: G.getDropdownOptionGuidFromObject(componentType),
      [GC.FIELD_COMPONENT_MANUFACTURER]: G.getDropdownOptionGuidFromObject(componentManufacturer),
    };
  },
  makeOptionsForSelect: ({ configGroup }) => ({
    [GC.FIELD_COMPONENT_TYPE]: R.path(['dropdownOptions', GC.FLEET_COMPONENT_TYPE], configGroup),
    [GC.FIELD_COMPONENT_MANUFACTURER]: R.path(['dropdownOptions', GC.FLEET_COMPONENT_MANUFACTURER], configGroup),
  }),
  CustomForm: (props) => (
    <EquipmentComponentForm
      {...props}
      configs={props.trailerConfigs}
      branchGuid={props.primaryObjectBranchGuid}
    />
  ),
};

export const trailerEquipmentComponentSettings = {
  ...truckEquipmentComponentSettings,
  report: {
    ...report,
    [GC.FIELD_TYPE]: GC.TRAILER_PROFILE_UI_REPORTS,
    [GC.FIELD_GUID]: `${GC.TRAILER_PROFILE_UI_REPORTS}EquipmentComponent`,
  },
  endpoints: {
    list: 'trailerComponentList',
    createOrUpdate: 'trailerComponent',
    remove: 'getCurrentTrailerComponentEndpoint',
  },
};
